module.exports = __webpack_public_path__ + "static/DINWeb-Bold-a407b2546aeedeade21e31296945085e.woff";